<template>
  <div class="account-field">
    <label :for="id">{{ label }}<template v-if="required"> *</template></label>
    <div class="account-input-wrap" :class="{ 'has-error': error }">
      <i class="now-ui-icons ui-1_lock-circle-open" aria-hidden="true"></i>
      <input
        :id="id"
        :value="value"
        :type="visible ? 'text' : 'password'"
        autocomplete="new-password"
        :aria-invalid="Boolean(error)"
        :aria-required="required"
        :aria-describedby="error ? `${id}-error` : null"
        @input="$emit('input', $event.target.value)"
      >
      <button
        type="button"
        class="account-password-visibility"
        :aria-label="visible ? 'Masquer le mot de passe' : 'Afficher le mot de passe'"
        @click="$emit('update:visible', !visible)"
      >
        <i :class="visible ? 'fas fa-eye-slash' : 'fas fa-eye'" aria-hidden="true"></i>
      </button>
    </div>
    <span v-if="error" :id="`${id}-error`" class="account-field-error" role="alert">{{ error }}</span>
  </div>
</template>

<script>
export default {
  name: 'UserPasswordField',
  props: {
    id: { type: String, required: true },
    value: { type: String, default: '' },
    label: { type: String, required: true },
    required: Boolean,
    visible: Boolean,
    error: { type: String, default: '' }
  }
}
</script>
